.checkbox {
  align-items: center;
  display: flex;
  justify-content: flex-end;

  &.is-groupby-header {
    justify-content: flex-start;
  }

  .groupby-header-detail {
    padding-left: 10px;

    & > b {
      margin-right: 5px;
    }
  }
}
